import { Font } from '@/types'
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component
export class ThemeHandler extends Vue {
  @Getter themeFont!: Font

  $themeInsertFont () {
    const style = document.createElement('link')
    style.rel = 'stylesheet'
    style.href = this.$themeFontLink

    document.head.appendChild(style)
  }

  get $themeStyle () {
    return {
      fontFamily: this.$themeFontFamily,
    }
  }

  get $themeFontFamily () {
    switch (this.themeFont) {
      case Font.PT_MONO: {
        return '"PT Mono", monospace'
      }
      case Font.POPPINS: {
        return '"Poppins", sans-serif'
      }
      case Font.MERRIWEATHER: {
        return '"Merriweather", serif'
      }
      default: {
        return ''
      }
    }
  }

  get $themeFontLink (): string {
    switch (this.themeFont) {
      case Font.POPPINS: {
        return 'https://fonts-googleapis-com.universal-music.de/css?family=Poppins:400,600,700&display=swap'
      }
      case Font.MERRIWEATHER: {
        return 'https://fonts-googleapis-com.universal-music.de/css2?family=Merriweather:wght@300;400;900&display=swap'
      }
      case Font.PT_MONO: {
        return 'https://fonts-googleapis-com.universal-music.de/css2?family=PT+Mono&display=swap'
      }
      default: {
        return ''
      }
    }
  }
}
